import letrusAPI from 'APIs/letrusAPI/axiosInstance';

export interface AccessRequest {
  token: string;
}

export const accessService = (data: AccessRequest) =>
  letrusAPI('/api/v1/schoolsnetwork/auth/', {method: 'post', data});

export interface RecoverPassword {
  uidb64: string;
  token: string;
  new_password1: string;
  new_password2: string;
}

export const RecoverPasswordService = (data: RecoverPassword) =>
  letrusAPI('/password_reset_confirm/', {
    method: 'post',
    data,
  });
